module.exports = __webpack_public_path__ + "images/status-close.770e993f.png";